import types from './types'
import params from './params'

const spec = { types, params }

// export everything
export {
  spec as default,

  params,
  spec,
  types
}
